import { IconName } from '@aloft/toolkit-sui';

import { TkOrderListfield } from '../types.ts';

export const getTkv2SortIcon = (
  field: TkOrderListfield,
  sortState: { field: TkOrderListfield; dir: 'asc' | 'desc' },
): IconName => {
  if (field === sortState.field) {
    return sortState.dir === 'asc' ? 'arrow-up' : 'arrow-down';
  }
  return 'arrow-up-down';
};
